/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2023-01-27",
    versionChannel: "nightly",
    buildDate: "2023-01-27T00:23:31.974Z",
    commitHash: "175d1319864ffa606146d34a661f03da5b172a57",
};
